import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-pie-grid-icon',
    templateUrl: './pie-grid-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PieGridIconComponent {}
